import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { App } from 'antd';

import { QuestionForm } from '../views/QuestionForm';
import { createFormData } from '../../../../../utils/common/createFormData';
import {
    useReadQuestionByIdQuery,
    useUpdateQuestionMutation,
} from '../../../services';
import { QuestionProps } from '../../../interfaces/questions.interface';
import { mapQuestionToFormValues, preparePayload } from '../utils/options';

export const QuestionEditContainer = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const { notification } = App.useApp();

    const [updateQuestion, { isSuccess, isLoading }] =
        useUpdateQuestionMutation();

    const { data: question } = useReadQuestionByIdQuery(+id);

    useEffect(() => {
        if (isSuccess) {
            notification.success({
                message: 'Вопрос успешно изменен',
                placement: 'top',
            });
            navigate(-1);
        }
    }, [isSuccess]);

    const onSave = async (values: QuestionProps) => {
        const payload = preparePayload(values);
        await updateQuestion({
            id: Number(id),
            body: createFormData(payload),
        });
    };

    if (!id || !question) {
        return null;
    }

    return (
        <QuestionForm
            initialValues={mapQuestionToFormValues(question)}
            onSave={onSave}
            loading={isLoading}
        />
    );
};
